import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import {
  IconButton,
  ListItemSecondaryAction,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText
} from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';
import { deleteBranchThreePlAction } from '../redux/actions/branch-actions';
import { SnackbarComponent } from '../../../../core/utils/components/snackbar-component';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: 'inline'
  },
  heading: {
    margin: theme.spacing(2)
  },
  fab: {
    width: '100%'
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  clientLogo: {
    height: '8rem',
    width: '8rem',
    objectFit: 'contain'
  },
  list: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  maringCancel: {},
  formButtons: {
    marginTop: theme.spacing(4)
  },
  listBullet: {
    textDecoration: ''
  }
}));

function ThreePLList({ branch }) {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, status: 'success', message: '' });
  const showSnackbar = (status, message) => setSnackbar({ open: true, status, message });
  const close = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <ListItem className={classes.listBullet}>
        <ListItemText primary={branch?.three_pl_partners?.name} secondary={null}></ListItemText>
        <ListItemSecondaryAction>
          <IconButton edge="end" aria-label="comments" onClick={() => setIsOpen(true)}>
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
      <CloseModal
        open={isOpen}
        handleModalClose={close}
        setIsOpen={setIsOpen}
        three_pl_name={branch?.three_pl_partners?.name}
        branch={branch}
        showSnackbar={showSnackbar}
      />
      <SnackbarComponent
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        severity={snackbar.status}
        message={snackbar.message}
      />
    </div>
  );
}

function CloseModal(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  // The partner is only removed once the admin confirms it here.
  const onConfirm = () => {
    dispatch(deleteBranchThreePlAction(props.branch.id, { showSnackbar: props.showSnackbar }));
  };
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <strong>Confirm 3PL deletion </strong>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to stop all orders from being sent to{' '}
            <strong> {props.three_pl_name}</strong>? This will redirect all orders back to the
            branch.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.margin}
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
            onClick={() => {
              props.setIsOpen(false);
              onConfirm();
            }}
          >
            Yes
          </Button>
          <Button
            className={classes.maringCancel}
            onClick={() => props.setIsOpen(false)}
            variant="outlined"
            size="large"
            color="secondary"
            fullWidth={true}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export function BranchRemoveThirdPartyPartnerComponent() {
  const classes = useStyles();
  const { branch } = useSelector((state) => state.branch);
  return (
    <div className={classes.list}>
      <>
        <ThreePLList branch={branch} />
      </>
    </div>
  );
}
